export default __webpack_public_path__ + "static/media/price-tag.e6db26b7.svg";